// Generated by scripts/prepare-mediapipe-assets.mjs from the files shipped in this build.
export const TRACKING_ASSETS = {
  "model": {
    "path": "/models/blaze_face_short_range.tflite",
    "size": 229746
  },
  "wasm": {
    "simd": {
      "loader": {
        "path": "/vendor/mediapipe/wasm/vision_wasm_internal.js",
        "size": 323377
      },
      "binary": {
        "path": "/vendor/mediapipe/wasm/vision_wasm_internal.wasm",
        "size": 11756954
      }
    },
    "noSimd": {
      "loader": {
        "path": "/vendor/mediapipe/wasm/vision_wasm_nosimd_internal.js",
        "size": 323180
      },
      "binary": {
        "path": "/vendor/mediapipe/wasm/vision_wasm_nosimd_internal.wasm",
        "size": 10960242
      }
    }
  }
} as const;
